import React from 'react';
import {
    ResponsiveContainer,
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
} from 'recharts';
import { useTheme, Flex, Text } from '@chakra-ui/react';
import CustomBarCursor from '../UI/CustomBarCursor';
import CustomTooltip from '../UI/CustomTooltip';

const InadimplenciaChart = ({ data = [] }) => {
    const theme = useTheme();

    const AXIS_COLOR = theme.colors?.gray?.[400] || '#A0AEC0';
    const BAR_COLOR = theme.colors?.secondary || theme.colors?.green?.[400] || '#48BB78';

    if (!data || data.length === 0) {
        return (
            <Flex justify="center" align="center" h="100%">
                <Text color="gray.500">Nenhum dado de inadimplência disponível.</Text>
            </Flex>
        );
    }

    return (
        <ResponsiveContainer width="100%" height="100%">
            <BarChart
                data={data}
                margin={{ top: 20, right: 30, left: 20, bottom: 10 }}
                barCategoryGap="35%"
            >
                <CartesianGrid
                    strokeDasharray="3 3"
                    stroke="rgba(255, 255, 255, 0.1)"
                    vertical={false}
                />
                <XAxis
                    dataKey="label"
                    tick={{ fill: AXIS_COLOR, fontSize: 12 }}
                    axisLine={false}
                    tickLine={false}
                />
                <YAxis
                    tickFormatter={(v) =>
                        v >= 1000
                            ? `R$${(v / 1000).toFixed(0)}k`
                            : `R$${v}`
                    }
                    tick={{ fill: AXIS_COLOR, fontSize: 12 }}
                    axisLine={false}
                    tickLine={false}
                />
                <Tooltip
                    content={<CustomTooltip format="currency" />}
                    cursor={<CustomBarCursor />}
                    wrapperStyle={{ zIndex: 99 }}
                />
                <Bar
                    dataKey="total"
                    name="Em Aberto"
                    fill={BAR_COLOR}
                    radius={[6, 6, 0, 0]}
                    maxBarSize={80}
                />
            </BarChart>
        </ResponsiveContainer>
    );
};

export default InadimplenciaChart;
